<template>
    <span style="width: 100%; flex: 0 0 100%;">
        <v-row
            dense
            class="Schedule"
            v-for="(field, index) in fields"
            :key="index"
        >
            <v-col
                cols="12"
                sm="3"
                md="2"
                class="Schedule__prefix"
            >
                {{ field.name }}
            </v-col>
            <v-col
                cols="12"
                sm="9"
                md="10"
            >
                <div class="FieldHelpWrap">
                    <div class="FieldHelpWrap__input">
                        <ValidationProvider
                            rules="max:255"
                            v-slot="{ errors }"
                        >
                            <v-text-field
                                v-model="fieldData[field.model]"
                                label="Hours Available"
                                outlined
                                :error-messages="errors"
                                @change="setFieldData"
                            />
                        </ValidationProvider>
                    </div>
                    <div
                        class="FieldHelpWrap__help"
                        v-if="helpText"
                    >
                        <HelpModal
                            v-if="helpText && index === 0"
                            :text="helpText"
                            :title="helpTitle"
                        />
                    </div>
                </div>
            </v-col>
        </v-row>
    </span>
</template>

<script>
import SubmissionBoilerplate from '@/views/Public/Field/Fields/SubmissionBoilerplate';

export default {
    mixins: [ SubmissionBoilerplate ],

    data() {
        return {
            fieldData: {
                sunday: '',
                monday: '',
                tuesday: '',
                wednesday: '',
                thursday: '',
                friday: '',
                saturday: '',
            },

            fields: [
                {
                    name: 'Sunday',
                    model: 'sunday',
                },
                {
                    name: 'Monday',
                    model: 'monday',
                },
                {
                    name: 'Tuesday',
                    model: 'tuesday',
                },
                {
                    name: 'Wednesday',
                    model: 'wednesday',
                },
                {
                    name: 'Thursday',
                    model: 'thursday',
                },
                {
                    name: 'Friday',
                    model: 'friday',
                },
                {
                    name: 'Saturday',
                    model: 'saturday',
                }
            ]
        };
    },

    methods: {
        loadFieldData() {
            if (this.submission) {
                this.fieldData.sunday = this.submission.sunday;
                this.fieldData.monday = this.submission.monday;
                this.fieldData.tuesday = this.submission.tuesday;
                this.fieldData.wednesday = this.submission.wednesday;
                this.fieldData.thursday = this.submission.thursday;
                this.fieldData.friday = this.submission.friday;
                this.fieldData.saturday = this.submission.saturday;
            }

            this.setFieldData();
        },

        setFieldData() {
            this.fieldData = {
                sunday: this.fieldData.sunday,
                monday: this.fieldData.monday,
                tuesday: this.fieldData.tuesday,
                wednesday: this.fieldData.wednesday,
                thursday: this.fieldData.thursday,
                friday: this.fieldData.friday,
                saturday: this.fieldData.saturday,
            };

            this.storeFieldData();
        },
    }
};
</script>
<style lang="scss">
.Schedule__prefix {
    display: flex;
    flex-flow: row wrap;
    align-content: center;
    align-items: center;

    @media(min-width: 0px) {
        margin-bottom: 28px;
    }
}
</style>
